// @ts-nocheck
/**
 * @generated
 * @file HomepageHeader (generated by DevLink)
 *
 * This file is generated by DevLink from a Webflow component. Manual edits are discouraged.
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
"use client";

import { DEVLINK_SCOPE_CLASS } from "./devlinkScope";
import Block from "./webflow_modules/Basic/components/Block";
import BlockContainer from "./webflow_modules/Layout/components/BlockContainer";
import Grid from "./webflow_modules/Layout/components/Grid";
import Heading from "./webflow_modules/Basic/components/Heading";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";
import Section from "./webflow_modules/Layout/components/Section";
import * as _interactions from "./webflow_modules/interactions";

const _interactionsData = JSON.parse(
  '{"events":{"e":{"id":"e","name":"","animationType":"preset","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"4900e0fa-0f5d-9409-3d6b-547ac5d6a411","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"4900e0fa-0f5d-9409-3d6b-547ac5d6a411","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":[{"continuousParameterGroupId":"a-p","smoothing":50,"startsEntering":true,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1773151916769},"e-2":{"id":"e-2","name":"","animationType":"preset","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-2","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"193a056f-1efb-1bec-4291-df43e6609cd1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"193a056f-1efb-1bec-4291-df43e6609cd1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":[{"continuousParameterGroupId":"a-2-p","smoothing":50,"startsEntering":true,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1773157818052},"e-3":{"id":"e-3","name":"","animationType":"preset","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-3","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"42aec6e9-9fac-12e6-3b0c-a2d03f3123b2","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[],"config":[{"continuousParameterGroupId":"a-3-p","smoothing":50,"startsEntering":true,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1774017223946}},"actionLists":{"a":{"id":"a","title":"SoT Impact Scroll 5","continuousParameterGroups":[{"id":"a-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":50,"actionItems":[{"id":"a-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-1","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b4a"]},"yValue":50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-2","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b45"]},"yValue":-50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-1","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b4a"]},"yValue":-50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-2","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b45"]},"yValue":50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]}]}],"createdOn":1712155236371},"a-2":{"id":"a-2","title":"SoT Impact Scroll 6","continuousParameterGroups":[{"id":"a-2-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":50,"actionItems":[{"id":"a-2-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-1","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b4a"]},"yValue":50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-2-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-2","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b45"]},"yValue":-50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-2-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-1","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b4a"]},"yValue":-50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-2-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-2","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b45"]},"yValue":50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]}]}],"createdOn":1712155236371},"a-3":{"id":"a-3","title":"SoT Impact Scroll 7","continuousParameterGroups":[{"id":"a-3-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":50,"actionItems":[{"id":"a-3-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-1","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b4a"]},"yValue":50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-3-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-2","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b45"]},"yValue":-50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-3-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-1","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b4a"]},"yValue":-50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-3-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".impact-media-column-2","selectorGuids":["057194a1-f239-1374-4856-8b0ef9674b45"]},"yValue":50,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]}]}],"createdOn":1712155236371}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

/**
 * Props for {@link HomepageHeader}
 */
export type HomepageHeaderProps = {
  customAttributes?: Record<string, unknown>;
  link2?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
  text1?: React.ReactNode;
  text2?: React.ReactNode;
  text4?: React.ReactNode;
  text6?: React.ReactNode;
  text7?: React.ReactNode;
  title?: React.ReactNode;
};

/**
 * HomepageHeader
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
export function HomepageHeader({
  customAttributes = {},

  link2 = {
    href: "/impact",
  },

  text1 = (
    <>
      {
        "Support a carefully selected mix of restoration projects that make the biggest difference."
      }
      <br />
    </>
  ),
  text2 = (
    <>
      {
        "Follow the impact you’re making: fully tracked with field updates, imagery and GPS."
      }
      <br />
    </>
  ),
  text4 = "See the impact",
  text6 = <br />,
  text7 = (
    <>
      {"More than "}
      <br />
    </>
  ),
  title = "Restore the Planet From Forest to Reef",
}: HomepageHeaderProps) {
  _interactions.useInteractions(_interactionsData);

  return (
    <div
      className={DEVLINK_SCOPE_CLASS}
      style={{
        display: "contents",
      }}
    >
      <Section
        className={"hero-header-wrapper"}
        data-w-id={"42aec6e9-9fac-12e6-3b0c-a2d03f3123b2"}
        grid={{
          type: "section",
        }}
        tag={"section"}
      >
        <Block className={"hero-background"} tag={"div"}>
          <Block className={"hero-overlay"} tag={"div"}>
            <Grid className={"hero-grid-mobile"} tag={"div"}>
              <Block
                className={"impact-media-row-1"}
                id={"w-node-_42aec6e9-9fac-12e6-3b0c-a2d03f3123b6-3f3123b2"}
                tag={"div"}
              >
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_42aec6e9-9fac-12e6-3b0c-a2d03f3123b7-3f3123b2"}
                  tag={"div"}
                >
                  <Image
                    alt={""}
                    className={"impact-image"}
                    height={"auto"}
                    loading={"lazy"}
                    src={
                      "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a84640_main-large%20(1)7.jpg"
                    }
                    width={"auto"}
                  />
                </Block>
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_42aec6e9-9fac-12e6-3b0c-a2d03f3123b9-3f3123b2"}
                  tag={"div"}
                >
                  <Block className={"impact-video-wrapper"} tag={"div"}>
                    <Image
                      alt={""}
                      className={"thumbnail-video"}
                      height={"auto"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a84639_PF-barrier.jpg"
                      }
                      width={"auto"}
                    />
                    <HtmlEmbed
                      className={"html-video-render"}
                      content={
                        '<video autoplay loop muted playsinline data-wf-ignore="true" data-object-fit="cover" style="width: 100%; height: 100%; object-fit: cover;">\n    <source src="https://storage.googleapis.com/sumthing/brochure-website/homepage-videos/CG-Nursery_compressed2.mp4" type="video/mp4">\n  </video>'
                      }
                    />
                  </Block>
                </Block>
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_42aec6e9-9fac-12e6-3b0c-a2d03f3123bd-3f3123b2"}
                  tag={"div"}
                >
                  <Block className={"impact-video-wrapper"} tag={"div"}>
                    <Image
                      alt={""}
                      className={"thumbnail-video"}
                      height={"auto"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a8463d_65e042cdf7b047d56a27f55c_BJF-Nursery.jpg"
                      }
                      width={"auto"}
                    />
                    <HtmlEmbed
                      className={"html-video-render"}
                      content={
                        '<video autoplay loop muted playsinline data-wf-ignore="true" data-object-fit="cover" style="width: 100%; height: 100%; object-fit: cover;">\n    <source src="https://storage.googleapis.com/sumthing/brochure-website/homepage-videos/BJF-Nursery_compressed.mp4" type="video/mp4">\n  </video>'
                      }
                    />
                  </Block>
                </Block>
              </Block>
              <Block
                className={"impact-media-row-2"}
                id={"w-node-_42aec6e9-9fac-12e6-3b0c-a2d03f3123c1-3f3123b2"}
                tag={"div"}
              >
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_42aec6e9-9fac-12e6-3b0c-a2d03f3123c2-3f3123b2"}
                  tag={"div"}
                >
                  <Block className={"impact-video-wrapper"} tag={"div"}>
                    <Image
                      alt={""}
                      className={"thumbnail-video"}
                      height={"auto"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a84639_PF-barrier.jpg"
                      }
                      width={"auto"}
                    />
                    <HtmlEmbed
                      className={"html-video-render"}
                      content={
                        '<video autoplay loop muted playsinline data-wf-ignore="true" data-object-fit="cover" style="width: 100%; height: 100%; object-fit: cover;">\n    <source src="https://storage.googleapis.com/sumthing/brochure-website/homepage-videos/PF-barrier_compressed.mp4" type="video/mp4">\n  </video>'
                      }
                    />
                  </Block>
                </Block>
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_42aec6e9-9fac-12e6-3b0c-a2d03f3123c6-3f3123b2"}
                  tag={"div"}
                >
                  <Image
                    alt={""}
                    className={"impact-image"}
                    height={"auto"}
                    loading={"lazy"}
                    src={
                      "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a84644_main-large%20(1)4.jpg"
                    }
                    width={"auto"}
                  />
                </Block>
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_42aec6e9-9fac-12e6-3b0c-a2d03f3123c8-3f3123b2"}
                  tag={"div"}
                >
                  <Block className={"impact-video-wrapper"} tag={"div"}>
                    <Image
                      alt={""}
                      className={"thumbnail-video"}
                      height={"auto"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a8463b_65e0425e38b64e3bbbcff49b_Mos-Kelp.jpg"
                      }
                      width={"auto"}
                    />
                    <HtmlEmbed
                      className={"html-video-render"}
                      content={
                        '<video autoplay loop muted playsinline data-wf-ignore="true" data-object-fit="cover" style="width: 100%; height: 100%; object-fit: cover;">\n    <source src="https://storage.googleapis.com/sumthing/brochure-website/homepage-videos/Mos-Kelp_compressed.mp4" type="video/mp4">\n  </video>'
                      }
                    />
                  </Block>
                </Block>
              </Block>
            </Grid>
            <Grid className={"hero-grid-desktop"} tag={"div"}>
              <Block
                className={"impact-media-column-1"}
                id={"w-node-_42aec6e9-9fac-12e6-3b0c-a2d03f3123cd-3f3123b2"}
                tag={"div"}
              >
                <Block className={"impact-media-block"} tag={"div"}>
                  <Image
                    alt={""}
                    className={"impact-image"}
                    height={"auto"}
                    loading={"lazy"}
                    src={
                      "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a84640_main-large%20(1)7.jpg"
                    }
                    width={"auto"}
                  />
                </Block>
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_42aec6e9-9fac-12e6-3b0c-a2d03f3123d0-3f3123b2"}
                  tag={"div"}
                >
                  <Image
                    alt={""}
                    className={"impact-image"}
                    height={"auto"}
                    loading={"lazy"}
                    src={
                      "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a8464c_image%209.jpg"
                    }
                    width={"auto"}
                  />
                </Block>
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_42aec6e9-9fac-12e6-3b0c-a2d03f3123d2-3f3123b2"}
                  tag={"div"}
                >
                  <Image
                    alt={""}
                    className={"impact-image"}
                    height={"auto"}
                    loading={"lazy"}
                    src={
                      "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a84644_main-large%20(1)4.jpg"
                    }
                    width={"auto"}
                  />
                </Block>
              </Block>
              <Block
                className={"impact-media-column-2"}
                id={"w-node-_42aec6e9-9fac-12e6-3b0c-a2d03f3123d4-3f3123b2"}
                tag={"div"}
              >
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_42aec6e9-9fac-12e6-3b0c-a2d03f3123d5-3f3123b2"}
                  tag={"div"}
                >
                  <Image
                    alt={""}
                    className={"impact-image"}
                    height={"auto"}
                    loading={"lazy"}
                    src={
                      "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b16734e8a597a84632_PHOTO-2023-03-16-12-21-29.webp"
                    }
                    width={"auto"}
                  />
                </Block>
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_42aec6e9-9fac-12e6-3b0c-a2d03f3123d7-3f3123b2"}
                  tag={"div"}
                >
                  <Block className={"impact-video-wrapper"} tag={"div"}>
                    <Image
                      alt={""}
                      className={"thumbnail-video"}
                      height={"auto"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a8463d_65e042cdf7b047d56a27f55c_BJF-Nursery.jpg"
                      }
                      width={"auto"}
                    />
                    <HtmlEmbed
                      className={"html-video-render"}
                      content={
                        '<video autoplay loop muted playsinline data-wf-ignore="true" data-object-fit="cover" style="width: 100%; height: 100%; object-fit: cover;">\n    <source src="https://storage.googleapis.com/sumthing/brochure-website/homepage-videos/BJF-Nursery_compressed.mp4" type="video/mp4">\n  </video>'
                      }
                    />
                  </Block>
                </Block>
                <Block
                  className={"impact-media-block"}
                  id={"w-node-_42aec6e9-9fac-12e6-3b0c-a2d03f3123db-3f3123b2"}
                  tag={"div"}
                >
                  <Image
                    alt={""}
                    className={"impact-image"}
                    height={"auto"}
                    loading={"lazy"}
                    src={
                      "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a84648_image%206.jpg"
                    }
                    width={"auto"}
                  />
                </Block>
              </Block>
              <Block
                className={"hero-grid-mask"}
                id={"w-node-_42aec6e9-9fac-12e6-3b0c-a2d03f3123dd-3f3123b2"}
                tag={"div"}
              />
            </Grid>
            <HtmlEmbed
              content={
                '<style>\n  body { margin: 0; }\n\n  @keyframes col1-in {\n    from { transform: translateY(50px); }\n    to   { transform: translateY(-50px); }\n  }\n  @keyframes col2-in {\n    from { transform: translateY(-50px); }\n    to   { transform: translateY(50px); }\n  }\n  @keyframes row1-in {\n    from { transform: translateX(-130px); }\n    to   { transform: translateX(0); }\n  }\n  @keyframes row2-in {\n    from { transform: translateX(-30px); }\n    to   { transform: translateX(-200px); }\n  }\n\n  [class*="impact-media-column-1"],\n  [class*="impact-media-column-2"],\n  [class*="impact-media-row-1"],\n  [class*="impact-media-row-2"] {\n    animation-duration: 1.2s;\n    animation-timing-function: ease-out;\n    animation-fill-mode: both;\n  }\n\n  [class*="impact-media-column-1"] { animation-name: col1-in; }\n  [class*="impact-media-column-2"] { animation-name: col2-in; }\n  [class*="impact-media-row-1"]    { animation-name: row1-in; animation-delay: 0.1s; }\n  [class*="impact-media-row-2"]    { animation-name: row2-in; animation-delay: 0.2s; }\n</style>'
              }
            />
          </Block>
        </Block>
        <Block className={"hero-content"} tag={"div"}>
          <BlockContainer
            className={"container-main"}
            grid={{
              type: "container",
            }}
            tag={"div"}
          >
            <Block className={"hero-flex-box"} tag={"div"}>
              <Block className={"hero-flex-block-inner"} tag={"div"}>
                <Heading className={"h1"} tag={"h1"}>
                  {title}
                </Heading>
                <Block className={"hero-body"} tag={"div"}>
                  <Block className={"hero-main-text"} tag={"div"}>
                    <Paragraph className={"body-medium"}>{text1}</Paragraph>
                    <Paragraph className={"body-medium"}>{text2}</Paragraph>
                  </Block>
                </Block>
                <Block className={"hero-buttons"} tag={"div"}>
                  <Link
                    button={true}
                    className={"button-yellow-full hero"}
                    options={{
                      href: "/membership",
                    }}
                  >
                    {text6}
                  </Link>
                  <Link
                    button={true}
                    className={"button-black-empty hero"}
                    options={link2}
                  >
                    {text4}
                  </Link>
                </Block>
                <Block
                  className={"hero-link-to-supporters-wrapper"}
                  tag={"div"}
                >
                  <Block className={"supporter-image-wrapper"} tag={"div"}>
                    <Image
                      alt={""}
                      className={"supporter-image"}
                      height={"auto"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a84651_1581618432715.jpeg"
                      }
                      width={"auto"}
                    />
                    <Image
                      alt={""}
                      className={"supporter-image secondary"}
                      height={"auto"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b16734e8a597a8462b_1683881452634.jpeg"
                      }
                      width={"auto"}
                    />
                    <Image
                      alt={""}
                      className={"supporter-image third"}
                      height={"auto"}
                      loading={"lazy"}
                      src={
                        "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b026b26734e8a597a8464f_1705659471882.jpeg"
                      }
                      width={"auto"}
                    />
                  </Block>
                  <Block
                    className={"body-small"}
                    tag={"div"}
                    {...customAttributes}
                  >
                    {text7}
                  </Block>
                </Block>
              </Block>
            </Block>
          </BlockContainer>
        </Block>
      </Section>
    </div>
  );
}
